
import * as Yup from 'yup';

export type TInitialValues = {
  name: string;
  email: string;
  phoneNumber: string;
  insuranceCompany: string;
  vop: boolean;
};

export const initialValues: TInitialValues = {
  name: '',
  email: '',
  phoneNumber: '',
  insuranceCompany: '',
  vop: false,
};

export const validation = Yup.object().shape({
  name: Yup.string()
    .test('len', 'Meno musí obsahovať najmenej 5 znakov', (val) =>
      val ? val.length >= 5 : false,
    )
    .required('Tento údaj je povinný'),
  phoneNumber: Yup.string()
    .test('phone', 'Telefónne číslo nemá požadovaný tvar', (val) => {
      if (val) {
        const trimmed = val.replace(/\s+/g, '');
        if (trimmed.length !== 13) {
          return false;
        }

        return !(trimmed[0] !== '+');
      }
      return false;
    })
    .required('Tento údaj je povinný'),
  insuranceCompany: Yup.string()
    .test('len', 'Názov poisťovne musí obsahovať najmenej 3 znaky', (val) =>
      val ? val.length >= 3 : false,
    )
    .required('Tento údaj je povinný'),
  vop: Yup.boolean().oneOf([true], 'Akceptovanie podmienok je povinné'),
});